import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { MaterialsSection } from './components/MaterialsSection';
import { JourneySection } from './components/JourneySection';
import { BonusSection } from './components/BonusSection';
import { WorkFormatSection } from './components/WorkFormatSection';
import { AudienceSection } from './components/AudienceSection';
import { MidPageCTA } from './components/MidPageCTA';
import { ValueStackSection } from './components/ValueStackSection';
import { PurchaseSection } from './components/PurchaseSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel - Fresh Install
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', '790333870788238');
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen font-sans" data-id="element-0" data-mp="38kgkgbhctqoz">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1" data-mp="3dmfqxu8e53q5">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=790333870788238&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="3diruonbka37q" />
      </noscript>

      <UrgencyBar data-id="element-3" data-mp="st2heeqiaph5" />

      <main data-id="element-4" data-mp="swqd9kjfbnz1">
        <HeroSection data-id="element-5" data-mp="swgm3tmn7arr" />
        <PainSection data-id="element-6" data-mp="35ypsmahfq2i" />
        <SolutionSection data-id="element-7" data-mp="35gm54lhq9kk" />
        <MaterialsSection data-id="element-8" data-mp="34nbhsjeuzx5" />
        <JourneySection data-id="element-9" data-mp="3uct4hmy40t22" />
        <BonusSection data-id="element-10" data-mp="3udazyhcy738x" />
        <WorkFormatSection data-id="element-11" data-mp="3ubzumd3utnfp" />
        <AudienceSection data-id="element-12" data-mp="3uevpttobhy0g" />
        <MidPageCTA data-id="element-13" data-mp="d4e6rwfspiya" />
        <ValueStackSection data-id="element-14" data-mp="d4xr1jsx4jfh" />
        <PurchaseSection data-id="element-15" data-mp="d45ti3frgbmk" />

        <section className="py-6 px-4 bg-white" data-id="element-16" data-mp="d2bgrcen7ptk">
          <div className="max-w-3xl mx-auto text-center" data-id="element-17" data-mp="86mh792mi8x9">
            <p className="text-lg md:text-xl font-semibold text-gray-600 italic" data-id="element-18" data-mp="3gle90gn0mze4">
              Creado por Aula Mater, proyecto educativo enfocado en facilitar el
              trabajo docente
            </p>
          </div>
        </section>

        <GuaranteeSection data-id="element-19" data-mp="3qc948ai8p9bp" />
      </main>

      <footer className="bg-gray-900 text-gray-400 text-center py-8 px-4" data-id="element-20" data-mp="3qd0rmy1oo0qw">
        <div className="max-w-3xl mx-auto space-y-3" data-id="element-21" data-mp="3liwm8j82g0rx">
          <p className="text-sm text-gray-300" data-id="element-22" data-mp="2xuda1slwb3uk">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-xs leading-relaxed" data-id="element-23" data-mp="2suquvdmibdj4">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-24" data-mp="yh6dz9hnc29g" />
    </div>;
}